import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import Layout from './layout'

import { Routes } from '@/components/youtube/Routes'
import YoutubeChannelsList from '@/components/youtube/YoutubeChannelsList'

const apiUrl = 'https://ilya1.com/api'

function SlugHandler() {
  const [activeTab, setActiveTab] = useState('Youtube')
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <Layout>
      <div className="flex justify-center items-center h-full">
        <div className="bg-white mx-0 p-0 w-full md:max-w-[1024px] min-h-[640px] mx-auto in-content h-full">
          {['Youtube', 'Routes'].map((tab, index) => {
            return (
              <button
                key={index}
                className={`${
                  activeTab === tab ? 'border-b-2 border-blue-500' : 'border-b border-transparent'
                } flex-grow text-gray-500 py-2 px-2 focus:outline-none`}
                onClick={() => {
                  setActiveTab(tab)
                }}
              >
                {tab}
              </button>
            )
          })}

          {activeTab === 'Routes' && (
            <div className="text-sm pt-4 pb-4">
              <Routes apiUrl="https://ilya1.com/api" title="ilya1.com" />
            </div>
          )}

          {activeTab === 'Youtube' && <div>{isClient && <YoutubeChannelsList title="Youtube" apiUrl={apiUrl} />}</div>}
        </div>
      </div>
    </Layout>
  )
}

export default SlugHandler
